import React, { createContext, useState } from 'react';

export const ModalContext = createContext();

export const ModalProvider = ({ children }) => {
  const [modalContent, setModalContent] = useState(null);
  const [resolvePromise, setResolvePromise] = useState(null);

  const showModal = (content) => {
    return new Promise((resolve) => {
      document.activeElement?.blur();
      setModalContent(content);
      setResolvePromise(() => resolve);
    });
  };

  const closeModal = (result) => {
    setModalContent(null);
    if (resolvePromise) {
      resolvePromise(result);
      setResolvePromise(null);
    }
  };

  return (
    <ModalContext.Provider value={{ modalContent, showModal, closeModal }}>
      {children}
    </ModalContext.Provider>
  );
};
